import React from 'react';
import CapButton from '../../CapButton';
import CapRow from '../../CapRow';
import CapIcon from '../../CapIcon';

const SecondaryButton = ({ iconName, text, style, ...rest }) => {
  return (
    <CapButton
      type="secondary"
      style={{ padding: '0 1rem', height: '2.2rem', ...style }}
      {...rest}
    >
      <CapRow type="flex" align="middle" style={{ flexWrap: 'nowrap' }}>
        <CapIcon
          type={iconName}
          svgProps={{ height: '1rem', width: 'auto' }}
          style={{ marginRight: '0.5rem' }}
        />
        {text}
      </CapRow>
    </CapButton>
  );
};

export default SecondaryButton;
